import React, { useRef } from 'react'
import {
  BsSearch,
  BsBookmark,
  BsFullscreen,
  BsPrinter,
  BsChevronLeft,
  BsChevronRight,
  BsZoomIn,
  BsZoomOut,
} from "react-icons/bs";
import Tippy from "@tippyjs/react";
import { Button } from "reactstrap";
import { ReactComponent as DownloadIcon } from "../../../../assets/utils/images/svgs/downloadCircleDarlBlue.svg";
import { useState, useEffect } from "react";

const PDFControls = ({ displayedPages, activePosition, setActivePosition, pageChanged, setPageChanged, pageRefs, isFullscreen, pageNumber, setPageNumber, numPages, pdfUrl, setScale, scale, viewerRef, textLayerRef, setSearchTerm, searchTerm }) => {

  const [showSearchInput, setShowSearchInput] = useState(false);
  const searchWrapperRef = useRef(null);

  const [pdfScaleShow, setPdfScaleShow] = useState(Math.round(scale * 100 + 40));
  useEffect(() => {
    isFullscreen ? setPdfScaleShow(Math.round(scale * 100)) : setPdfScaleShow(Math.round(scale * 100 + 40));
  }, [isFullscreen, scale]);

  useEffect(() => {
    const pageRef = pageRefs.current?.[pageNumber - 1];
    if (pageRef) {
      pageRef.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [pageChanged]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchWrapperRef.current && !searchWrapperRef.current.contains(event.target)) {
        setShowSearchInput(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const zoomIn = () => setScale(prev => Math.min(prev + 0.1, isFullscreen ? 2.0 : 1.6));
  const zoomOut = () => setScale(prev => Math.max(prev - 0.1, isFullscreen ? 0.5 : 0.1));

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      viewerRef.current?.requestFullscreen().catch(err => {
        console.error("Fullscreen error:", err.message);
      });
    } else {
      document.exitFullscreen();
    }
  };

  const downloadPDF = () => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    const date = new Date().toISOString().split('T')[0];
    const seconds = new Date().getSeconds().toString().padStart(2, '0');
    const downloadName = `document-${date}-${seconds}.pdf`;

    const finalFilename = downloadName.toLowerCase().endsWith('.pdf')
      ? downloadName
      : `${downloadName}.pdf`;

    link.download = finalFilename;
    link.click();
  };

  const changePage = offset => {
    setPageChanged(prev => !prev);
    const newPage = pageNumber + offset;
    if (newPage >= 1 && newPage <= numPages) {
      setPageNumber(newPage);

      if (offset > 0) {
        setActivePosition(1);
      } else {
        setActivePosition(0);
      }
    }
  };

  const handlePrint = () => {
    try {
      let base64Data = pdfUrl;

      if (pdfUrl.startsWith("data:application/pdf;base64,")) {
        base64Data = pdfUrl.replace("data:application/pdf;base64,", "");
      }

      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.right = '100%';
      iframe.style.bottom = '100%';
      iframe.src = blobUrl;

      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        URL.revokeObjectURL(blobUrl);
      };

      document.body.appendChild(iframe);
    } catch (error) {
      console.error("Failed to print PDF:", error);
    }
  };


  const handleSearch = async () => {
    // if (!searchText.trim() || !pdfUrl) {
    //   setSearchResults([]);
    //   return;
    // }

    // setIsSearching(true);
    // // setError(null);

    // try {
    //   const loadingTask = pdfjs.getDocument({ data: atob(pdfUrl.split(',')[1]) });
    //   const pdf = await loadingTask.promise;
    //   const results = []

    //   for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
    //     const page = await pdf.getPage(pageNum);
    //     const textContent = await page.getTextContent();
    //     const pageText = textContent.items
    //       .map((item) => item.str)
    //       .join(' ')
    //       .toLowerCase();

    //     if (pageText.includes(searchText.toLowerCase())) {
    //       results.push({
    //         pageNumber: pageNum,
    //         text: `Found "${searchText}" on page ${pageNum}`,
    //       });
    //     }
    //   }

    //   setSearchResults(results);

    //   if (results.length > 0) {
    //     setPageNumber(results[0].pageNumber);
    //     setPageChanged(prev => !prev);
    //   }
    // } catch (err) {
    //   console.error('Error searching PDF:', err);
    //   // setError('Failed to search PDF content');
    // } finally {
    //   setIsSearching(false);
    // }

    // if (!searchTerm.trim() || !pdfUrl) {
    //   setMatches([]);
    //   return;
    // }

    // if (!pdfInstance || !searchTerm) return;

    // let newMatches = [];

    // for (let pageNum = 1; pageNum <= pdfInstance.numPages; pageNum++) {
    //   const page = await pdfInstance.getPage(pageNum);
    //   const textContent = await page.getTextContent();
    //   console.log(textContent);

    //   for (let item of textContent.items) {
    //     if (
    //       item.str.toLowerCase().includes(searchTerm.toLowerCase()) &&
    //       item.transform
    //     ) {
    //       const [x, , , fontHeight, y] = item.transform;

    //       newMatches.push({
    //         page: pageNum,
    //         str: item.str,
    //         position: {
    //           x,
    //           y,
    //           width: item.width,
    //           height: fontHeight,
    //         },
    //       });
    //     }
    //   }
    // }

    // setMatches(newMatches);
    // setPageNumber(1);
    // updateHighlights(newMatches[0]);
    if (!searchTerm || !textLayerRef.current) return;

    const textSpans = textLayerRef.current.querySelectorAll("span");
    textSpans.forEach((span) => {
      const originalText = span.textContent;
      const regex = new RegExp(`(${searchTerm})`, "gi");
      if (regex.test(originalText)) {
        span.innerHTML = originalText.replace(regex, "<mark>$1</mark>");
      } else {
        span.innerHTML = originalText;
      }
    });
  };


  return (
    <>
      <div id="print-container" style={{ display: 'none' }}></div>
      <div className="pdf-controler">

        <div className="d-flex align-items-center first-col-svg ">
          <div className="position-relative" ref={searchWrapperRef}>
            <Tippy
              content={'Search'}
              placement="top"
              duration={[250, 180]}
              hideOnClick={false}
            >
              <div>
                <Button onClick={() => { setShowSearchInput(!showSearchInput); setSearchTerm(''); }}>
                  <BsSearch />
                </Button>
              </div>
            </Tippy>

            {showSearchInput && (
              <div className="position-absolute start-100 z-index-10 search-dropdown shadow bg-white rounded p-2">
                <div className="d-flex align-items-center gap-2 position-relative">
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    placeholder="Search in PDF..."
                    className="form-control form-control-sm"
                    style={{ width: '200px' }}
                  />
                  <Button className='d-flex position-absolute end-0' variant="outline-secondary" size="sm" onClick={handleSearch}>
                    <BsSearch />
                  </Button>
                </div>
              </div>
            )}
          </div>

          <Tippy
            content={'Bookmarks'}
            placement="top"
            duration={[250, 180]}
            hideOnClick={false}
          >
            <div>
              <Button >
                <BsBookmark />
              </Button>
            </div>
          </Tippy>


          <Tippy
            content={'Fullscreen'}
            placement="top"
            duration={[250, 180]}
            hideOnClick={false}
          >
            <div>
              <Button onClick={toggleFullscreen}>
                <BsFullscreen />
              </Button>
            </div>
          </Tippy>
        </div>

        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center border-left border-right ps-2 pe-2">
            <Tippy
              content={'Zoom In'}
              placement="top"
              duration={[250, 180]}
              hideOnClick={false}
            >
              <div>
                <Button onClick={zoomIn}>
                  <BsZoomIn />
                </Button>
              </div>
            </Tippy>

            <span className="text-muted small">{pdfScaleShow}%</span>

            <Tippy
              content={'Zoom Out'}
              placement="top"
              duration={[250, 180]}
              hideOnClick={false}
            >
              <div>
                <Button onClick={zoomOut}>
                  <BsZoomOut />
                </Button>
              </div>
            </Tippy>
          </div>

          <div className="ps-3 pe-3 border-right page-navigation">
            <div className='form-control p-0 d-flex align-items-center'>
              <div className='border-right'>
                <Tippy
                  content={'Previous Page'}
                  placement="top"
                  duration={[250, 180]}
                  hideOnClick={false}
                >
                  <div>
                    <Button
                      onClick={() => changePage(-1)}
                      disabled={pageNumber <= 1}
                    >
                      <BsChevronLeft />
                    </Button>
                  </div>
                </Tippy>
              </div>

              <div>
                {displayedPages.map((page, index) => (
                  <span key={index} className={`fw-semibold border-right ${index === activePosition
                    ? "bg-blue"
                    : ""}`}>{page || '-'}</span>
                ))}
              </div>

              <div>
                <Tippy
                  content={'Next Page'}
                  placement="top"
                  duration={[250, 180]}
                  hideOnClick={false}
                >
                  <div>
                    <Button
                      onClick={() => changePage(1)}
                      disabled={pageNumber >= (numPages || 1)}
                    >
                      <BsChevronRight />
                    </Button>
                  </div>
                </Tippy>
              </div>
            </div>
          </div>


          <div className="d-flex align-items-center ps-2">
            <Tippy
              content={'Download'}
              placement="top"
              duration={[250, 180]}
              hideOnClick={false}
            >
              <div>
                <Button onClick={downloadPDF}>
                  <DownloadIcon />
                </Button>
              </div>
            </Tippy>


            <Tippy
              content={'Print'}
              placement="top"
              duration={[250, 180]}
              hideOnClick={false}
            >
              <div>
                <Button onClick={handlePrint}>
                  <BsPrinter />
                </Button>
              </div>
            </Tippy>
          </div>

        </div>
      </div>
    </>
  )
}

export default PDFControls
